import React from "react";
import { useNavigate } from "react-router-dom";
import "./BranchSelector.css"; // We'll create this CSS file next
import { NAIL_BRANCHES } from "../../utils/Const";

export default function BranchSelector() {
  const navigate = useNavigate();

  const handleSelect = (branch) => {
    navigate(`/${branch?.id}`);
  };

  return (
    <div className="branch-selector">
      <h1>Welcome to Kevin Nails</h1>
      <p>Please select your preferred branch:</p>

      <div className="branch-list">
        {NAIL_BRANCHES.map((branch) => (
          <div
            key={branch.id}
            className="branch-card"
            onClick={() => handleSelect(branch)}
          >
            <h2>{branch.name}</h2>
            <p>
              <strong>Email:</strong> {branch.email}
            </p>
            <p>
              <strong>Phone:</strong> {branch.phone}
            </p>
            <p>
              <strong>Address:</strong> {branch.address}
            </p>
            <button>Select</button>
          </div>
        ))}
      </div>
    </div>
  );
}
